const initialState = {};

const currentVariant = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default currentVariant;
